// extracted by mini-css-extract-plugin
module.exports = {"layout":"Layout_layout__3PvPc","container":"Layout_container__1nNA4","myVideo":"Layout_myVideo__3zv04"};